import React from 'react';

function UserIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <g>
        <path
          fill="#EF4136"
          d="M5.731 21.8C3.911 21.8 3 21.173 3 19.918c0-.724.217-1.462.65-2.214.433-.758 1.045-1.456 1.837-2.093.792-.644 1.74-1.16 2.843-1.55 1.103-.396 2.328-.594 3.675-.594 1.34 0 2.558.198 3.655.594 1.103.39 2.05.906 2.843 1.55.798.637 1.414 1.335 1.847 2.093.433.752.65 1.49.65 2.214 0 1.255-.91 1.882-2.731 1.882H5.731zm-.142-2.033H18.41c.102 0 .173-.02.213-.06.048-.034.071-.09.071-.171 0-.35-.148-.752-.446-1.208-.298-.456-.735-.899-1.31-1.328-.568-.436-1.269-.795-2.101-1.077-.826-.282-1.77-.423-2.833-.423-1.07 0-2.02.141-2.853.423-.825.282-1.526.64-2.101 1.077-.569.43-1.002.872-1.3 1.328-.298.456-.446.859-.446 1.208 0 .08.02.137.06.17.048.041.122.061.224.061zm6.416-7.386c-.84 0-1.6-.215-2.284-.645a4.838 4.838 0 01-1.625-1.75c-.406-.732-.609-1.544-.609-2.436 0-.872.203-1.667.61-2.385a4.77 4.77 0 011.634-1.72 4.19 4.19 0 012.274-.645c.833 0 1.59.215 2.274.644a4.608 4.608 0 011.625 1.71c.406.712.609 1.507.609 2.386 0 .892-.203 1.707-.61 2.445-.399.732-.94 1.315-1.624 1.752a4.189 4.189 0 01-2.274.644zm0-2.023c.44 0 .84-.121 1.198-.363a2.65 2.65 0 00.873-1.006c.223-.423.335-.906.335-1.449 0-.523-.111-.99-.335-1.399a2.526 2.526 0 00-.873-.966 2.14 2.14 0 00-1.198-.352c-.433 0-.832.12-1.198.362-.365.235-.66.557-.883.966-.217.41-.325.876-.325 1.399 0 .537.108 1.02.325 1.45.223.422.518.754.883.995a2.13 2.13 0 001.198.363z"
        ></path>
      </g>
    </svg>
  );
}

export default UserIcon;
